import { ClipboardBulletListLtr20Regular, Info20Regular } from '@fluentui/react-icons';
import { QueueListIcon } from '@heroicons/react/20/solid';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const LogsOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const LogsDetailsPage = lazyPage(() => import('./tools/details/pages/DetailsPage'));
const FtpDownloadJobPage = lazyPage(() => import('./tools/ftp-download-jobs/pages/FtpDownloadJobPage'));

const logsModuleConfig = createModuleConfig({
  key: 'logs',
  name: 'Logs',
  domain: { title: 'Logs', icon: QueueListIcon, shouldHide: true },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Logs Overview',
      path: '/logs', 
      element: <LogsOverviewPage />, 
      nav: { name: 'Overview', icon: ClipboardBulletListLtr20Regular }
    },
    { 
      key: 'details',
      name: 'Details',
      title: 'Log Details',
      path: '/logs/details', 
      element: <LogsDetailsPage />, 
      nav: { name: 'Details', icon: Info20Regular }
    },
    {
      key: 'ftp-download-jobs',
      name: 'Ftp Download Job Log',
      title: 'Ftp Download Job Log',
      path: '/logs/ftp-download-jobs/:id',
      element: <FtpDownloadJobPage />,
      nav: { name: 'Ftp Download Job Log', icon: Info20Regular },
      shouldHide: true
    },
  ],
});

export default logsModuleConfig;
